module.exports = __webpack_public_path__ + "static/img/3层.ab43f86.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/3层.png
// module id = fpGl
// module chunks = 0